(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cr-cart"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-cr-line-qty]').forEach(btn => {
      btn.addEventListener('click', () => {
        const wrap = btn.closest('.cr-pdp__qty-stepper');
        if (!wrap) return;
        const input = wrap.querySelector('input');
        const delta = parseInt(btn.dataset.crDelta, 10) || 0;
        const next = Math.max(0, parseInt(input.value, 10) + delta);
        input.value = next;
        const form = document.getElementById('cr-cart-form');
        if (form) form.requestSubmit();
      });
    });

    const upsellBtn = document.querySelector('[data-cr-upsell-add]');
    if (upsellBtn) {
      upsellBtn.addEventListener('click', async () => {
        const card = upsellBtn.closest('[data-cr-cart-upsell]');
        const variantId = parseInt(upsellBtn.dataset.crVariantId, 10);
        if (!variantId) return;
        if (card) card.setAttribute('data-state', 'adding');
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 }),
          });
          if (!res.ok) throw new Error('add failed');
          if (card) card.setAttribute('data-state', 'added');
          window.location.reload();
        } catch (e) {
          if (card) card.removeAttribute('data-state');
          if (window.crToast) window.crToast('Could not add — please try again.');
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cr-product-main"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const form = document.getElementById('cr-pdp-form');
    if (!form) return;
    const variantInput = form.querySelector('[data-cr-variant-id]');
    const addBtn = form.querySelector('.cr-pdp__add');
    const pills = form.querySelectorAll('.cr-pdp__pill');
    const qtyInput = form.querySelector('#cr-pdp-qty');

    function formatMoney(cents) {
      return '$' + (Number(cents) / 100).toFixed(2);
    }

    function setBtnLoading(isLoading, originalText) {
      if (!addBtn) return;
      if (isLoading) {
        addBtn.dataset.crOriginalText = addBtn.textContent;
        addBtn.disabled = true;
        addBtn.classList.add('is-loading');
        addBtn.innerHTML = '<span class="cr-spinner" aria-hidden="true"></span><span style="margin-left:0.5rem">Adding…</span>';
      } else {
        addBtn.disabled = false;
        addBtn.classList.remove('is-loading');
        addBtn.textContent = originalText || addBtn.dataset.crOriginalText || 'Add to cart';
        delete addBtn.dataset.crOriginalText;
      }
    }

    // Intercept submit — AJAX add, stay on PDP, show toast + bump cart count
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const variantId = parseInt(variantInput.value, 10);
      const quantity = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      if (!variantId) return;
      const originalText = addBtn ? addBtn.textContent : '';
      setBtnLoading(true);
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: quantity }),
        });
        if (!res.ok) {
          const err = await res.json().catch(() => null);
          throw new Error((err && err.description) || 'Could not add to cart');
        }
        // Refresh cart badge in header
        if (window.crRefreshCartCount) {
          await window.crRefreshCartCount();
        } else {
          // Fallback — fetch cart count manually
          const cartRes = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
          if (cartRes.ok) {
            const cart = await cartRes.json();
            document.querySelectorAll('[data-cr-cart-count]').forEach(el => {
              el.textContent = cart.item_count;
              if (cart.item_count > 0) el.removeAttribute('hidden');
            });
          }
        }
        if (window.crToast) {
          window.crToast('Added to your basket.');
        }
        setBtnLoading(false, originalText);
      } catch (err) {
        setBtnLoading(false, originalText);
        if (window.crToast) {
          window.crToast(err.message || 'Could not add — please try again.');
        }
      }
    });

    // Quantity stepper
    form.querySelectorAll('[data-cr-qty]').forEach(btn => {
      btn.addEventListener('click', () => {
        const delta = parseInt(btn.dataset.crQty, 10);
        const next = Math.max(1, parseInt(qtyInput.value, 10) + delta);
        qtyInput.value = next;
      });
    });

    // Image gallery thumbs
    const mainImg = document.getElementById('cr-pdp-main-img');
    document.querySelectorAll('[data-cr-thumb]').forEach(thumb => {
      thumb.addEventListener('click', () => {
        document.querySelectorAll('[data-cr-thumb]').forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
        if (mainImg && thumb.dataset.crLarge) {
          mainImg.src = thumb.dataset.crLarge;
          mainImg.srcset = '';
          mainImg.alt = thumb.dataset.crAlt || mainImg.alt;
        }
      });
    });

    // Variant selection — read product JSON from the script tag
    const dataEl = document.querySelector('[data-cr-pdp-product]');
    let product = null;
    try { product = dataEl ? JSON.parse(dataEl.textContent) : null; } catch (e) { product = null; }
    if (!product || !product.variants || product.variants.length <= 1) return;

    // Track currently selected option values (init from selected variant)
    const selected = [];
    product.options.forEach((opt, idx) => {
      const initialVariant = product.variants.find(v => v.id === parseInt(variantInput.value, 10));
      selected[idx] = (initialVariant && initialVariant.options) ? initialVariant.options[idx] : opt.values[0];
    });

    pills.forEach(pill => {
      pill.addEventListener('click', () => {
        const value = pill.dataset.crOptionValue;
        const positionIdx = parseInt(pill.dataset.crOptionPosition, 10) - 1;
        if (Number.isFinite(positionIdx)) selected[positionIdx] = value;

        // Mark this pill active, deactivate siblings in same option group
        const wrapper = pill.parentElement;
        wrapper.querySelectorAll('.cr-pdp__pill').forEach(p => p.classList.remove('is-active'));
        pill.classList.add('is-active');

        // Find matching variant
        const match = product.variants.find(v =>
          v.options.every((val, i) => val === selected[i])
        );
        if (match) {
          variantInput.value = match.id;
          if (addBtn) {
            if (match.available) {
              addBtn.disabled = false;
              addBtn.textContent = 'Add to cart · ' + formatMoney(match.price);
            } else {
              addBtn.disabled = true;
              addBtn.textContent = 'Sold out';
            }
          }
          // Update URL with ?variant= for shareable deep links
          const url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          history.replaceState({}, '', url.toString());
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    const header = document.querySelector('[data-cr-header]');
    if (!header) return;
    let lastY = 0;
    function onScroll() {
      const y = window.scrollY;
      if (y > 80 && lastY <= 80) header.classList.add('is-scrolled');
      else if (y <= 80 && lastY > 80) header.classList.remove('is-scrolled');
      lastY = y;
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();

  } catch(e) { console.error(e); }
})();
})();
